import {
  listSchema,
  zTenantContentApiKey,
  zTenantDetail,
  zTenantListItem,
  type ListMeta,
  type TenantContentApiKey,
  type TenantDetail,
  type TenantListItem,
} from '@cockpit/api-contract'
import { api } from '@/lib/apiClient'
import { envelope } from './unwrap'
import { parseContract } from './parseContract'

const zTenantList = listSchema('tenants', zTenantListItem)
const zTenantEnvelope = envelope('tenant', zTenantDetail)

export async function list(
  params: { page?: number; perPage?: number } = {},
): Promise<{ tenants: TenantListItem[]; meta: ListMeta }> {
  const { data } = await api.get('/tenants', { params })
  return parseContract(zTenantList, data, 'zTenantList')
}

export async function detail(id: string): Promise<TenantDetail> {
  const { data } = await api.get(`/tenants/${id}`)
  return parseContract(zTenantEnvelope, data, 'zTenantEnvelope')
}

export async function create(payload: Record<string, unknown>): Promise<TenantDetail> {
  const { data } = await api.post('/tenants', { tenant: payload })
  return parseContract(zTenantEnvelope, data, 'zTenantEnvelope')
}

export async function update(id: string, payload: Record<string, unknown>): Promise<TenantDetail> {
  const { data } = await api.patch(`/tenants/${id}`, { tenant: payload })
  return parseContract(zTenantEnvelope, data, 'zTenantEnvelope')
}

export async function remove(id: string): Promise<void> {
  await api.delete(`/tenants/${id}`)
}

// Content-API read key is returned in clear ONCE, on rotation. This response
// carries two sibling keys (`contentApiKey` + the refreshed `tenant`), so it is
// parsed directly rather than through the single-key `envelope()` unwrap.
export async function rotateContentApiKey(id: string): Promise<TenantContentApiKey> {
  const { data } = await api.post(`/tenants/${id}/rotate_content_api_key`)
  return parseContract(zTenantContentApiKey, data, 'zTenantContentApiKey')
}
